import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'App/store';
import {
  deleteShippingRestriction,
  getDeleteShippingRestrictionStatus,
} from '../../deliveryMethodsSlice';

function useDeleteShippingRestriction() {
  const dispatch = useAppDispatch();
  const status = useSelector(getDeleteShippingRestrictionStatus);

  const deleteRestriction = useCallback(
    async (id: string) => {
      await dispatch(deleteShippingRestriction(id));
    },
    [dispatch],
  );

  return {
    deleteRestriction,
    isLoading: status === 'loading',
    isSuccess: status === 'success',
    isError: status === 'error',
    status,
  };
}

export default useDeleteShippingRestriction;
